import { TextField as GammaTextField } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type TextFieldProps = React.ComponentProps<typeof GammaTextField>

type Props = Omit<TextFieldProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

const TextField = ({ missingLabel, ...props }: Props) => (
  <GammaTextField
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
  />
)

type SelectProps = Omit<TextFieldProps, 'missingLabel' | 'selectValue'> & {
  missingLabel?: string
}

TextField.Select = function Select(props: SelectProps) {
  return (
    <GammaTextField.Select
      {...props}
      missingLabel={props.missingLabel ?? i18n.t('common.missing_field')}
      selectValue={i18n.t('common.select')}
    />
  )
}

export default TextField
